// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__1c6vP","link":"styles_link__adl0I"};